export * from "./waterMaterial.js";
//# sourceMappingURL=index.js.map